import { ModuleTagging } from '../types';

/**
 * Converts module tag path prefixes to a set of module slugs
 * @param tagPathPrefixes Array of tag path prefixes to match (e.g., ['grade:3'])
 * @param moduleTagging Array of module taggings to filter
 * @returns Set of module slugs with the given tag path prefixes
 */
export function buildModuleSlugSet(
  tagPathPrefixes: readonly string[],
  moduleTagging: readonly ModuleTagging[],
): Set<string> {
  return new Set(
    moduleTagging
      .filter((t) =>
        tagPathPrefixes.some((prefix) => t.tag.path.startsWith(prefix)),
      )
      .map((t) => t.module.slug),
  );
}
